import { jsx as m } from "react/jsx-runtime";
import { forwardRef as s } from "react";
import { NumericFormat as u, PatternFormat as l } from "react-number-format";
import { InputBase as i } from "../Input/InputBase.mjs";
function f(e) {
  return e.format !== void 0 && e.mask !== void 0;
}
function c(e) {
  return e.allowLeadingZeros !== void 0 || e.decimalScale !== void 0;
}
const d = s(
  (e, n) => {
    if (c(e)) {
      const { decimalScale: t, onChange: a, allowLeadingZeros: r, ...o } = e;
      return /* @__PURE__ */ m(
        u,
        {
          getInputRef: n,
          allowLeadingZeros: r,
          thousandSeparator: ",",
          decimalScale: t,
          onValueChange: a,
          customInput: i,
          ...o
        }
      );
    } else if (f(e)) {
      const { format: t, mask: a, onChange: r, ...o } = e;
      return /* @__PURE__ */ m(
        l,
        {
          getInputRef: n,
          format: t ?? "",
          allowEmptyFormatting: !0,
          mask: a,
          onValueChange: r,
          customInput: i,
          ...o
        }
      );
    } else
      return null;
  }
);
d.displayName = "MaskBase";
export {
  d as MaskBase
};
